import CurrentConversationGate from './CurrentConversationGate'
import Layout from './Layout'

export default function ConversationRouteWrapper() {
  return (
    <>
      <CurrentConversationGate />
      <Layout />
    </>
  )
}
